import { Alert, Box, Card, CardContent, Grid, Tab, Tabs } from '@mui/material';
import { cabecerasAdminSiHay, getEditToken, notificar } from '../lib/seguridad';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import VistaIzquierda from './vistaOrganismo/VistaIzquierda';
import TabPanel from './vistaOrganismo/TabPanel';
import ActividadesTab from './vistaOrganismo/ActividadesTab';
import SociosTab from './vistaOrganismo/SociosTab';
import AntecedentesTab from './vistaOrganismo/AntecedentesTab';
import toast from 'react-hot-toast';
import FuncionesTab from './vistaOrganismo/FuncionesTab';
import SolicitarEdicion from './vistaOrganismo/SolicitarEdicion';
import { imgToUrl } from '../lib/imgToUrl';
import ObjetivosTab from './vistaOrganismo/ObjetivosTab';

const VistaOrganismo = () => {
    const { nombre_empresa } = useParams();
    const [datosEmpresa, setDatosEmpresa] = useState(null);
    const [actividades, setActividades] = useState({});
    const [socios, setSocios] = useState({});
    const [antecedentes, setAntecedentes] = useState({});
    const [funciones, setFunciones] = useState([]);
    const [productosServicios, setProductosServicios] = useState({});
    const [objetivos, setObjetivos] = useState({});
    const [imagenes, setImagenes] = useState({});
    const [loaded, setLoaded] = useState(false);

    const [nuevasImagenes, setNuevasImagenes] = useState({});
    const [catalogoFiguras, setCatalogoFiguras] = useState([]);
    const getDatos = async () => {
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/organismo?nombre=${nombre_empresa}`)
            .then(res => res.json())
            .then(async (respuesta) => {
                if (respuesta.status === 'success') {
                    // obtener figura juridica
                    if (respuesta.data.figura_juridica) {
                        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/figuras_juridicas_organismos`)
                            .then(res => res.json())
                            .then((res) => {
                                setCatalogoFiguras(res.data);
                                let fig = res.data.find((figura) => figura.id == respuesta.data.figura_juridica);
                                respuesta.data.figura_juridica = fig.nombre;
                            });

                    } else {
                        respuesta.data.figura_juridica = respuesta.data.figura_juridica_otro;
                    }
                    setLoaded(true);
                    //console.log(respuesta.data);
                    setDatosEmpresa({ ...respuesta.data, galeria: Object.values(respuesta.data.imagenes).filter((i) => i.seccion === 'galeria' && i.paso == 'datos_generales') });
                    setSocios(respuesta.data.socios);
                    setAntecedentes(respuesta.data.antecedentes);
                    setObjetivos(() => {
                        let obj = {};
                        Object.keys(respuesta.data.objetivos).map((key) => {
                            try {
                                obj[key] = JSON.parse(respuesta.data.objetivos[key])
                            } catch (error) {
                                obj[key] = respuesta.data.objetivos[key];
                            }
                        }
                        )
                        return obj;
                    });
                    setFunciones(respuesta.data.funciones);
                    setActividades(respuesta.data.actividades);
                    setImagenes(respuesta.data.imagenes); //

                } else {
                    toast.error("Empresa no encontrada");
                }
            })
            .catch((err) => console.log(err));
    }
    //? Cuando alguno de los estados cambie, deberia actualizarse datosEmpresa: ??
    useEffect(() => {
        setDatosEmpresa((prevDatos) => ({
            ...prevDatos,
            actividades_economicas: actividades,
            socios,
            antecedentes,
            objetivos,
            funciones,
            imagenes,
        }));
    }, [actividades, socios, antecedentes, imagenes, objetivos, funciones]);


    const setData = (e, seccion = null, index = null) => {
        let newVal = e.target.value;
        let name = e.target.name;
        switch (tab) {
            case 0: // Socios
                if (name != 'imagenes') {
                    setSocios(newVal);
                } else {
                    // eliminar la imagen  de imagenes
                    setImagenes(newVal);
                }
                break;
            case 1: // antecedentes
                if (name != 'imagenes') {
                    setAntecedentes({ ...antecedentes, [name]: newVal });
                } else {
                    setImagenes(newVal);
                }
                break;
            case 2: // objetivos
                setObjetivos((prevDatos) => ({
                    ...prevDatos,
                    [name]: newVal
                }));
                break;
            case 3: //funciones
                if (name != 'imagenes') {
                    if (!name) {
                        setFunciones(newVal);
                    }
                } else {
                    setImagenes(newVal);
                }
                break;
            case 4: // actividades economicas
                if (name != 'imagenes') {
                    if (!name) {
                        setActividades(newVal);
                    }
                } else {
                    setImagenes(newVal);
                }
                break;
            default:
                break;
        }
    }

    const setDataIzq = (e) => {
        let newVal = e.target.value;
        let name = e.target.name;
        setDatosEmpresa((prev) => {
            let newD = { ...prev, [name]: newVal };
            return newD;
        });
    }

    const objectToFormData = (obj, formData, parentKey = '') => {
        formData = formData || new FormData();
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                const fullKey = parentKey ? `${parentKey}[${key}]` : key;
                if (value instanceof File) {
                    // Si el valor es un objeto File, agrégalo directamente al FormData
                    formData.append(fullKey, value);
                } else if (typeof value === 'object' && value !== null) {
                    // Si el valor es un objeto, llama recursivamente a la función para manejar la anidación
                    objectToFormData(value, formData, fullKey);
                } else {
                    // Si es un valor simple, agrégalo al FormData
                    formData.append(fullKey, value);
                }
            }
        }

        return formData;
    }

    const handleUpdate = async (seccion) => {
        window.scrollTo(0, 0);
        let bodyContent = {};
        let err, err1, err2;
        // asignar los datos dependiendo de la seccion
        switch (seccion) {
            case 'datos_generales':
                bodyContent = datosEmpresa;
                break;
            case 'socios':
                //console.log(socios);
                err = socios.map((socio) => {
                    let errs = Object.values(socio).map((dato) => {
                        let res = isNaN(dato) || dato == '';
                        return res;
                    })
                    return errs.includes(true);
                });
                if (err.includes(true)) {
                    return toast.error("Valida los campos");
                }
                bodyContent = { socios: [...socios], id: datosEmpresa.id, imagenes: imagenes.filter(i => i.paso == 'total_socios') };
                break;
            case 'antecedentes':
                err = Object.values(antecedentes).map((dato) => {
                    return dato == '';
                });
                if (err.includes(true)) {
                    return toast.error("No puede haber campos vacíos");
                }
                bodyContent = { ...antecedentes, id: datosEmpresa.id, imagenes: imagenes.filter(i => i.paso == 'antecedentes') };
                break;
            case 'objetivos':
                err = Object.keys(objetivos).map((key) => {
                    if (objetivos[key] === "" || objetivos[key] === null || objetivos[key] === undefined) {
                        return true;
                    }
                    if (Array.isArray(objetivos[key])) {
                        return objetivos[key].map((item) => {
                            return Object.keys(item).map((subKey) => {
                                if (item[subKey] === "" || item[subKey] === null || item[subKey] === undefined) {
                                    return true;
                                }
                                return false;
                            }).flat();
                        }).flat();
                    }

                    return false;
                }).flat();
                if (err.includes(true)) {
                    return toast.error("No puede haber campos vacíos");
                }
                bodyContent = { ...objetivos, id: datosEmpresa.id };
                break;
            case 'funciones':
                err = Object.values(funciones).map((dato) => {
                    return Object.values(dato).some(a => a == '');
                });
                if (err.includes(true)) {
                    return toast.error("No puede haber campos vacíos");
                }
                if (funciones.length === 0) {
                    return toast.error("Debe haber al menos una actividad/proceso de producción");
                }
                bodyContent = {
                    funciones, id: datosEmpresa.id, imagenes: imagenes.filter(i => i.paso == 'funciones_servicios'), imagenes_data: imagenes.filter(i => i.paso == 'funciones_servicios').map((i) => {
                        return {
                            paso: i.paso,
                            index: i.index,
                        };
                    })
                };
                break;
            case 'actividades_economicas':
                err = actividades.map((act) => {
                    if (act.giro_actividad == '') {
                        if (act.giro_otro == '') {
                            return true;
                        }
                    }
                    return false;
                });

                if (err.includes(true) || actividades.length == 0) {
                    return toast.error("No puede haber campos vacíos");
                }
                bodyContent = { actividades, id: datosEmpresa.id, imagenes: imagenes.filter(i => i.paso == 'actividades_economicas') };
                break;
        }
        bodyContent.seccion = seccion;
        // primero actualizar imagenes, despues actualizar datos
        const formData = objectToFormData(bodyContent);

        // actualizar imagenes
        let imgBody = { ...nuevasImagenes, seccion: seccion, id: datosEmpresa.id };
        const imgData = objectToFormData(imgBody);

        // llamada para actualizar los datos de la seccion

        formData.append("token", getEditToken(datosEmpresa.id));
        await fetch("https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/actualizar_organismo", {
            method: "POST",
            body: formData,
            headers: cabecerasAdminSiHay()
        })
            .then(res => res.json())
            .then((respuesta) => {
                notificar(respuesta);
            });
    }

    useEffect(() => {
        const init = async () => await getDatos();
        init();
    }, []);

    const [tab, setTab] = useState(0);
    const handleTab = (e, v) => {
        setTab(v);
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const [editable, setEditable] = useState(false);
    const handleEditStatus = () => {
        // manejar un estado para utilizar edicion en cada tab
        editable ? setEditable(false) : setEditable(true);
    }

    useEffect(() => {
        if (editable) {
            window.scrollTo(0, 0);
        }
    }, [editable]);

    const setImgs = async (seccion, data) => {
        switch (seccion) {
            case 'datos_generales':
                // en esta seccion solo hay logotipo y galeria (img y [imgs])
                if (Array.isArray(data)) {
                    // es galeria
                    //console.log(data);
                    let newData = { ...datosEmpresa, galeria: data };
                    setDatosEmpresa(newData);
                } else {
                    // es logotipo
                    let logo = await imgToUrl(data)
                    let newData = { ...datosEmpresa, logotipo: data };
                    setDatosEmpresa(newData);
                }
                break;
            case 'total_socios':
                //console.log(datosEmpresa);
                break;
            case 'antecedentes':
                break;
            case 'actividades_economicas':
                break;
            default:
                break;
        }
        //console.log(datosEmpresa.galeria.filter((i) => i.seccion == 'galeria'));
    };

    useEffect(() => {
        //console.log(datosEmpresa);
    }, [datosEmpresa]);

    if (loaded) {
        return (
            <Box sx={{ m: { lg: 4, xs: 0 } }}>
                <Grid container spacing={3}>
                    {datosEmpresa.status != 1 &&
                        <Grid item xs={12}>
                            <Alert severity="error">Este organismo es preliminar, los datos mostrados no estarán completos y/o no serán completamente correctos.</Alert>
                        </Grid>
                    }
                    {datosEmpresa.hasOwnProperty('nombre_comercial') && datosEmpresa.nombre_comercial &&
                        <Grid item xs={12} lg={4}>
                            <Card>
                                <CardContent>
                                    <VistaIzquierda setData={setDataIzq} editable={editable} datos={datosEmpresa} handleUpdate={() => { handleUpdate('datos_generales') }} setImgs={(data) => { setImgs('datos_generales', data) }} />
                                    <SolicitarEdicion empresa={datosEmpresa} setEditable={handleEditStatus} editable={editable} />
                                </CardContent>
                            </Card>
                        </Grid>
                    }

                    <Grid item xs={12} lg={8}>
                        <Card sx={{ display: { lg: 'block', xs: 'none' } }}>
                            <Tabs
                                value={tab}
                                onChange={handleTab}
                                variant='fullWidth'
                                scrollButtons="auto"
                            >
                                <Tab {...a11yProps(0)} label="Socios" />
                                <Tab {...a11yProps(1)} label="Antecedentes" />
                                <Tab {...a11yProps(2)} label="Objetivos" />
                                <Tab {...a11yProps(3)} label="Funciones y Servicios" />
                                <Tab {...a11yProps(4)} label="Actividades Económicas" />
                            </Tabs>
                            <CardContent>
                                {/* Socios */}
                                <TabPanel value={tab} index={0}>
                                    <SociosTab
                                        setImgs={(data) => { setImgs('total_socios', data) }}
                                        setData={setData}
                                        editable={editable}
                                        socios={socios}
                                        imagenes={imagenes}
                                        handleUpdate={() => { handleUpdate('socios') }} />
                                </TabPanel>
                                {/* Antecedentes */}
                                <TabPanel value={tab} index={1}>
                                    <AntecedentesTab
                                        setImgs={(data) => { setImgs('antecedentes', data) }}
                                        setData={setData}
                                        editable={editable}
                                        antecedentes={antecedentes}
                                        imagenes={imagenes}
                                        handleUpdate={() => { handleUpdate('antecedentes') }} />
                                </TabPanel>
                                {/* Objetivos */}
                                <TabPanel value={tab} index={2}>
                                    <ObjetivosTab setData={setData}
                                        editable={editable}
                                        datos={objetivos}
                                        imagenes={imagenes}
                                        handleUpdate={() => { handleUpdate('objetivos') }} />
                                </TabPanel>
                                {/* Funciones */}
                                <TabPanel value={tab} index={3}>
                                    {/* Guardar en otro componente */}
                                    <FuncionesTab setData={setData}
                                        editable={editable}
                                        datos={funciones}
                                        imagenes={imagenes}
                                        handleUpdate={() => { handleUpdate('funciones') }} />
                                </TabPanel>
                                <TabPanel value={tab} index={4}>
                                    <ActividadesTab setImgs={(data) => { setImgs('actividades_economicas', data) }}
                                        setData={setData}
                                        editable={editable}
                                        imagenes={imagenes} actividades={actividades}
                                        handleUpdate={() => { handleUpdate('actividades_economicas') }} />
                                </TabPanel>
                            </CardContent>
                        </Card>

                        <Card sx={{ display: { lg: 'none', xs: 'block' } }}>
                            <Tabs
                                value={tab}
                                onChange={handleTab}
                                variant='scrollable'
                                scrollButtons="auto"
                            >
                                <Tab {...a11yProps(0)} label="Socios" />
                                <Tab {...a11yProps(1)} label="Antecedentes" />
                                <Tab {...a11yProps(2)} label="Objetivos" />
                                <Tab {...a11yProps(3)} label="Funciones y Servicios" />
                                <Tab {...a11yProps(4)} label="Actividades Económicas" />
                            </Tabs>

                            {/* Socios */}
                            <TabPanel value={tab} index={0}>
                                <SociosTab socios={socios} imagenes={imagenes} editable={editable} setData={setData} />
                            </TabPanel>
                            {/* Antecedentes */}
                            <TabPanel value={tab} index={1}>
                                <AntecedentesTab antecedentes={antecedentes} imagenes={imagenes} editable={editable} setData={setData} />
                            </TabPanel>
                            {/* Objetivos */}
                            <TabPanel value={tab} index={2}>
                                <ObjetivosTab setImgs={(data) => { setImgs('objetivos', data) }} setData={setData} editable={editable} datos={objetivos} imagenes={imagenes} handleUpdate={() => { handleUpdate('objetivos') }} />
                            </TabPanel>
                            <TabPanel value={tab} index={3}>
                                <FuncionesTab imagenes={imagenes} editable={editable} setData={setData} />
                            </TabPanel>
                            {/* Actividades Economicas */}
                            <TabPanel value={tab} index={4}>
                                {/* Guardar en otro componente */}
                                <ActividadesTab imagenes={imagenes} actividades={actividades} editable={editable} setData={setData} />
                            </TabPanel>
                        </Card>
                    </Grid>
                </Grid>

            </Box >
        )
    }

}


export default VistaOrganismo